
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    activeElementsIndex: Number
  }
}
